/**
 *
 * DefaultPage
 *
 */

import React, { useState } from 'react';
import { pick } from 'lodash-es';
import { useLocation } from 'react-router-dom';
import Main from 'components/PageLayout/Main/index.jsx';
import MetaTags from 'components/MetaTags/index.jsx';
import ArchiveIndex from 'components/ArchiveIndex/index.jsx';
import PhotoBook from 'components/PhotoBook/Loadable.js';
import StudentsConsents from 'components/imageUse/StudentsConsents/index.jsx';
import Groups from 'components/dashboard/Groups/index.jsx';
import GroupDetails from 'components/dashboard/Groups/GroupDetails/index.jsx';
import Users from 'components/dashboard/Users/index.jsx';
import User from 'components/dashboard/Users/User/index.jsx';
import SchoolRole from 'components/dashboard/Users/SchoolRole/index.jsx';
import Student from 'components/dashboard/Users/User/Student.jsx';
import Settings from 'components/dashboard/Settings/index.jsx';
import Payments from 'components/dashboard/Payments/index.jsx';
import InviteUsers from 'components/dashboard/Users/InviteUsers/index.jsx';
import ImportUsers from 'components/dashboard/Users/ImportUsers/index.jsx';
import PrintPage from 'components/dashboard/Users/InviteUsers/PrintPage/index.jsx';
import Conversations from 'components/Conversations/index.jsx';
import CloseToRefButton from 'components/dashboard/CloseToRefButton.jsx';
import NotFound from './NotFound.jsx';

const pathPages = [
  { re: /^photobook/, Component: PhotoBook },
  { re: /^students\/consents/, Component: StudentsConsents },
  { re: /^(admin|manage)\/users\/invite/, Component: InviteUsers },
  { re: /^(admin|manage)\/users\/import/, Component: ImportUsers },
  { re: /^(admin|manage)\/users\/admin\/\d+/, Component: Student },
  { re: /^(admin|manage)\/users\/(parent|employee|student|staff)/, Component: User },
  { re: /^(admin|manage)\/users\/role/, Component: SchoolRole },
  { re: /^(admin|manage)\/users/, Component: Users },
  { re: /^(admin|manage)\/groups\/(school|foundation|general|classes|archive)\/\d+/, Component: GroupDetails },
  { re: /^(admin|manage)\/groups/, Component: Groups },
  { re: /^(admin|manage)\/settings/, Component: Settings },
  { re: /^(admin|manage)\/payments/, Component: Payments },
  { re: /^archive$/, Component: ArchiveIndex },
  { re: /^(conversations)/, Component: Conversations },
  { re: /.*/, Component: NotFound },
];

function DefaultPage(props) {
  const { pathname, hash } = useLocation();
  const page = pathPages.find((o) => o.re.test(pathname.slice(1)));
  const { Component, fullPage } = page;
  const [meta, setMeta] = useState({});
  const { title, description, ...rest } = meta;
  const control = pathname.startsWith('/manage/') ? <CloseToRefButton /> : undefined;
  return (
    <Main
      shaded={!fullPage}
      control={control}
      {...props}
      {...rest}
    >
      <MetaTags tags={pick(meta, ['title', 'description'])} />
      {hash.startsWith('#print') ? <PrintPage {...props} /> : <Component {...props} setMeta={setMeta} />}
    </Main>
  );
}

export default DefaultPage;
